import { fetchOnlineCountryList } from '@/api/components/components.js'
// 获取当前的国家信息
const curCountry = localStorage.getItem('UL_CurCountry')
const state = {
  countryArr: [],
  curCountry: curCountry
}

const mutations = {
  UPDATE_COUNTRY_ARR: (state, arr) => {
    state.countryArr = arr
  }
}

const actions = {
  getCountryList({ commit }, view) {
    fetchOnlineCountryList().then(res => [
      commit('UPDATE_COUNTRY_ARR', res.data)
    ])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
